"use strict";

var _classCallCheck = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var utils_1 = __importDefault(require("@nexys/utils"));

var _utils_1$default$numb = utils_1.default.number,
    formatNumber = _utils_1$default$numb.formatNumber,
    formatKprice = _utils_1$default$numb.formatKprice;

var getType = function getType(t) {
  if (t === 'email' || t === 'password') {
    return t;
  }

  return 'text';
};

var setValue = function setValue(type) {
  var v = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  switch (type) {
    case 'number':
    case 'kPrice':
    case 'price':
    case 'rate':
      if (isNaN(Number(v))) {
        return '';
      }

      return v || '';

    default:
      return v || '';
  }
};

var formatValue = function formatValue(type) {
  var v = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  switch (type) {
    case 'number':
      return formatNumber(Number(v), 0);

    case 'kPrice':
      return formatKprice(Number(v)) + ' k$';

    case 'price':
      return formatNumber(Number(v), 2) + ' $';

    case 'rate':
      return formatNumber(Number(v), 2) + ' %';

    default:
      return String(v) || '';
  }
};

var numberTypes = ['number', 'kPrice', 'price', 'rate'];

var isNumberType = function isNumberType(type) {
  return numberTypes.includes(type);
};

var inputStyle = function inputStyle(type) {
  return isNumberType(type) ? {
    textAlign: 'right',
    paddingRight: '5px'
  } : {};
};

var wrapComponent = function wrapComponent() {
  return function (WrappedComponent) {
    return /*#__PURE__*/function (_react_1$default$Comp) {
      _inherits(Hoc, _react_1$default$Comp);

      var _super = _createSuper(Hoc);

      function Hoc(props) {
        var _this;

        _classCallCheck(this, Hoc);

        _this = _super.call(this, props);

        _this.processProps = function (props) {
          var type = getType(props.type);
          var typeFromProps = props.type ? props.type : type;
          var name = props.name;
          var value = setValue(typeFromProps, props.value);
          var disabled = props.disabled ? props.disabled : false;
          var autoFocus = props.autoFocus ? props.autoFocus : false;
          var fValue = formatValue(typeFromProps, props.value);
          var style = inputStyle(typeFromProps);
          _this.state = {
            type: type,
            typeFromProps: typeFromProps,
            name: name,
            value: value,
            fValue: fValue,
            style: style,
            disabled: disabled,
            autoFocus: autoFocus
          };
        };

        _this.handleChange = function (event) {
          var newValue = setValue(_this.state.typeFromProps, event.target.value);

          _this.setState({
            fValue: newValue
          });

          _this.props.onChange({
            name: _this.state.name,
            value: newValue
          });
        };

        _this.handleFocus = function () {
          _this.setState({
            fValue: _this.state.value
          });
        };

        _this.handleBlur = function () {
          var nValue = _this.state.fValue;

          _this.setState({
            value: nValue,
            fValue: formatValue(_this.props.type ? _this.props.type : _this.state.type, nValue)
          });

          if (_this.props.onBlur) {
            _this.props.onBlur({
              name: _this.state.name,
              value: nValue
            });
          }
        };

        _this.processProps(props);

        return _this;
      }

      _createClass(Hoc, [{
        key: "render",
        value: function render() {
          var className = 'form-control';
          return react_1.default.createElement(WrappedComponent, {
            className: className,
            type: this.state.type,
            placeholder: this.props.placeholder,
            value: this.state.fValue,
            onChange: this.handleChange,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            disabled: this.state.disabled ? true : undefined,
            style: this.state.style,
            autoFocus: this.state.autoFocus ? true : undefined
          });
        }
      }]);

      return Hoc;
    }(react_1.default.Component);
  };
};

exports.default = wrapComponent;